import { ActBreadcrumbToolbar } from './breadcrumb-toolbar/act-breadcrumb-toolbar.component';
import { ManualEntryDialogController } from './manual_entry_dialog/manual_entry_dialog.controller';
import { Table } from './table/act-table/actTable.directive';
import { StatusMenuButtonController } from './status-menu-button/status-menu-button.controller';
import { StatusLabelController } from './status_label/status_label.controller';
import { PhotoUploadController } from './photo_upload/photo-upload.controller';
import { FileUploadController } from './file_upload/file-upload.controller';
import { PaginatorController } from './paginator/paginator.controller';
import { ExportButtonController } from './export-button/export-button.controller';
import { StatusMenuButton } from './status-menu-button/status-menu-button.directive';
import { StatusLabel } from './status_label/status_label.directive';
import { PhotoUpload } from './photo_upload/photo-upload.directive';
import { FileUpload } from './file_upload/file-upload.directive';
import { Paginator } from './paginator/paginator.directive';
import { NavButton } from './nav-button/nav-button.directive';
import { ListDialogController } from './list_dialog/list_dialog.controller';
import { ExportButton } from './export-button/export-button.directive';
import { ErrorDialogController } from './error_dialog/error_dialog.controller';
import { ConfirmDialogController } from './confirm_dialog/confirm_dialog.controller';
import { CustomDialogController } from './custom_dialog/custom_dialog.controller';

// Forms
import { OperatorServiceForm } from './forms/operator-service/operator-service-form.component';
import { OperatorServiceFormController } from './forms/operator-service/operator-service-form.controller';
import { OperatorForm } from './forms/operator/operator-form.component';
import { OperatorFormController } from './forms/operator/operator-form.controller';
import * as SchemaFormModule from './json_schema_form/schema-form.module';
import { ActStep } from './stepper/act-step-generator.directive';
import { ActStepper } from './stepper/act-stepper-generator.directive';
import { StepperController } from './stepper/stepper.controller';
import { CollapsablePanel } from './collapsable-panel/collapsable-panel.directive';
import { CollapsablePanelController } from './collapsable-panel/collapsable-panel.controller';
import { DialogController } from './dialog/dialog.controller';
import { Chips } from './chips/chips.component';

import { TrafficLightStatus } from './traffic-light-status/traffic-light-status.component';
import { BreadcrumbToolbarController } from './breadcrumb-toolbar/act-breadcrumb-toolbar.controller';
import { SummaryChart } from './summary-chart/summary-chart.component';
import { SummaryChartController } from './summary-chart/summary-chart.controller';
import { SearchComponent } from './search/search.component';
import { SearchController } from './search/search.controller';
import { SpecialDayDialogController } from './special-day-dialog/special-day-dialog.controller';
import { SummaryBarController } from './summary_bar/summary-bar.controller';
import { ActSummaryBar } from './summary_bar/summary-bar.directive';
import { CappedProductInfoBannerController } from './capped-product-info-banner/capped-product-info-banner.controller';
import { CappedProductInfoBanner } from './capped-product-info-banner/capped-product-info-banner.component';
import { ChargeAccountReplacedProductsTableController } from './charge-account-replaced-products-table/charge-account-replaced-products-table.controller';
import { ChargeAccountReplacedProductsTableComponent } from './charge-account-replaced-products-table/charge-account-replaced-products-table.component';
import { ChargeAccountProductJourneysTableController } from './charge-account-product-journeys-table/charge-account-product-journeys-table.controller';
import { ChargeAccountProductJourneysTableComponent } from './charge-account-product-journeys-table/charge-account-product-journeys-table.component';
import { IControllerConstructor } from 'angular';
import { SearchNewController } from './search-new/search-new.controller';
import { SearchNew } from './search-new/search-new.component';
import { DetailFormatterController } from './detail-formatter/detail-formatter.controller';
import { DetailFormatter } from './detail-formatter/detail-formatter.component';
import { ChargeAccountSummaryCardComponent } from './charge-account-summary-card/charge-account-summary-card.component';
import { ChargeAccountSummaryCardController } from './charge-account-summary-card/charge-account-summary-card.controller';
import { UsageEventManagementDialogController } from './usage-event-management-dialog/usage-event-management-dialog.controller';
import { ChargeAccountStatementTableComponent } from './charge-account-statement-table/charge-account-statement-table.component';
import { ChargeAccountStatementTableController } from './charge-account-statement-table/charge-account-statement-table.controller';

export const initialise = () => {
  SchemaFormModule.initialise();

  /**
   * A module against which the major reusable components, often in the form of angular Directives, are registered
   */
  angular.module('app.components', [
    'actora.services',
    'ngMaterial',
    'pascalprecht.translate',
    'ngFileUpload',
    'ngImgCrop',
    'ngFileSaver',
    'ngSanitize'
  ])
    .config(['$compileProvider', ($compileProvider) => {
      $compileProvider.preAssignBindingsEnabled(true);
    }])
    .controller('SummaryBarController', <any>SummaryBarController)
    .controller('ListDialogController', <any>ListDialogController)
    .controller('ErrorDialogController', <any>ErrorDialogController)
    .controller('ManualEntryDialogController', <any>ManualEntryDialogController)
    .controller('ConfirmDialogController', <any>ConfirmDialogController)
    .controller('CustomDialogController', <any>CustomDialogController)
    .controller('ExportButtonController', <any>ExportButtonController)
    .controller('PaginatorController', <any>PaginatorController)
    .controller('PhotoUploadController', <any>PhotoUploadController)
    .controller('FileUploadController', <any>FileUploadController)
    .controller('StatusLabelController', <any>StatusLabelController)
    .controller('StatusMenuButtonController', <any>StatusMenuButtonController)
    .controller('BreadcrumbToolbarController', <any>BreadcrumbToolbarController)
    .controller('StepperController', <any>StepperController)
    .controller('CollapsablePanelController', <any>CollapsablePanelController)
    .directive('actTable', () => { return new Table(); })
    .directive('actStatusMenuButton', () => { return new StatusMenuButton(); })
    .directive('actStatusLabel', () => { return new StatusLabel(); })
    .directive('actSummaryBar', () => { return new ActSummaryBar(); })
    .component('trafficLightStatus', TrafficLightStatus)
    .directive('actPhotoUpload', () => { return new PhotoUpload(); })
    .directive('actFileUpload', () => { return new FileUpload(); })
    .directive('actPaginator', () => { return new Paginator(); })
    .directive('actNavButton', () => { return new NavButton(); })
    .directive('actExportButton', () => { return new ExportButton(); })
    .directive('actStep', () => { return new ActStep(); })
    .directive('actStepper', () => { return new ActStepper(); })
    .directive('actCollapsablePanel', () => { return new CollapsablePanel(); })
    .controller('DialogController', <any>DialogController)
    .component('actChips', Chips)
    .component('actBreadcrumbToolbar', ActBreadcrumbToolbar)
    .controller('OperatorServiceFormController', <any>OperatorServiceFormController)
    .component('operatorServiceForm', OperatorServiceForm)
    .controller('OperatorFormController', <any>OperatorFormController)
    .component('operatorForm', OperatorForm)
    .component('summaryChart', SummaryChart)
    .controller('SummaryChartController', <any>SummaryChartController)
    .component('search', SearchComponent)
    .controller('SearchController', <any>SearchController)
    .controller('SpecialDayDialogController', <any>SpecialDayDialogController)
    .controller('UsageEventManagementDialogController', <IControllerConstructor>UsageEventManagementDialogController)
    .controller('CappedProductInfoBannerController', <ng.IControllerConstructor>CappedProductInfoBannerController)
    .component('cappedProductInfoBanner', CappedProductInfoBanner)
    .controller('ChargeAccountReplacedProductsTableController', <ng.IControllerConstructor>ChargeAccountReplacedProductsTableController)
    .component('chargeAccountReplacedProductsTable', ChargeAccountReplacedProductsTableComponent)
    .controller('ChargeAccountProductJourneysTableController', <ng.IControllerConstructor>ChargeAccountProductJourneysTableController)
    .component('chargeAccountStatementTable', ChargeAccountStatementTableComponent)
    .controller('ChargeAccountStatementTableController', <ng.IControllerConstructor>ChargeAccountStatementTableController)
    .component('chargeAccountProductJourneysTable', ChargeAccountProductJourneysTableComponent)
    .component('chargeAccountSummaryCard', ChargeAccountSummaryCardComponent)
    .controller('ChargeAccountSummaryCardController', <ng.IControllerConstructor>ChargeAccountSummaryCardController)
    .controller('SearchNewController', <IControllerConstructor>SearchNewController)
    .component('actSearchNew', SearchNew)
    .controller('DetailFormatterController', <IControllerConstructor>DetailFormatterController)
    .component('actDetailFormatter', DetailFormatter);
};